import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { DEFAULT_FORM } from './StepperV2';
import styles from './StepperV2.module.scss';
import { CLASSES } from '../../helper/functions';
import { Form } from '../../store/QuestionStore';
import Icon from '../icon/Icon';
import Portal from '../portal/Portal';

interface StepperNavigationV2Props {
  prevDisabled?: boolean;
  nextDisabled?: boolean;
  isLast?: boolean;
  onPrev: () => void;
  onNext: () => void;
}

const StepperV2Navigation: React.FC<StepperNavigationV2Props> = ({
  prevDisabled = false,
  nextDisabled = false,
  isLast = false,
  onPrev = () => {},
  onNext = () => {},
}) => {
  return (
    <Portal root="footer">
      <div className={styles.formNavContainer}>
        <div
          className={CLASSES(styles.prevBtn, prevDisabled && styles.disable__)}
          onClick={() => onPrev()}
        >
          <Icon src={'/icons/back.svg'} />
          Prev
        </div>
        <div
          className={CLASSES(styles.nextBtn, nextDisabled && styles.disable__)}
          onClick={() => onNext()}
        >
          {isLast ? (
            'Submit'
          ) : (
            <>
              Next
              <Icon src={'/icons/next.svg'} />
            </>
          )}
        </div>
      </div>
    </Portal>
  );
};

export default StepperV2Navigation;
